import { deprecated, createAsyncAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import { mainState } from './types';
import {
  GetTotalRecommendParamType,
  GetTotalRecommendType,
  GetWordCloudType,
  GetPopularContentsType,
} from '../../lib/main/type';

const { createAction } = deprecated;

export const GET_TOTAL_RECOMMEND = 'main/GET_TOTAL_RECOMMEND' as const;
export const GET_TOTAL_RECOMMEND_SUCCESS = 'main/GET_TOTAL_RECOMMEND_SUCCESS' as const;
export const GET_TOTAL_RECOMMEND_ERROR = 'main/GET_TOTAL_RECOMMEND_ERROR' as const;

export const GET_WORD_CLOUD = 'main/GET_WORD_CLOUD' as const;
export const GET_WORD_CLOUD_SUCCESS = 'main/GET_WORD_CLOUD_SUCCESS' as const;
export const GET_WORD_CLOUD_ERROR = 'main/GET_WORD_CLOUD_ERROR' as const;

export const GET_POPULAR_CONTENTS = 'main/GET_POPULAR_CONTENTS' as const;
export const GET_POPULAR_CONTENTS_SUCCESS = 'main/GET_POPULAR_CONTENTS_SUCCESS' as const;
export const GET_POPULAR_CONTENTS_ERROR = 'main/GET_POPULAR_CONTENTS_ERROR' as const;

export const SET_SETTING_ID = 'main/SET_SETTING_ID' as const;

export const getTotalRecommendAsync = createAsyncAction(
  GET_TOTAL_RECOMMEND,
  GET_TOTAL_RECOMMEND_SUCCESS,
  GET_TOTAL_RECOMMEND_ERROR
)<GetTotalRecommendParamType, GetTotalRecommendType, AxiosError>();

export const getWordCloudAsync = createAsyncAction(
  GET_WORD_CLOUD,
  GET_WORD_CLOUD_SUCCESS,
  GET_WORD_CLOUD_ERROR
)<null, GetWordCloudType, AxiosError>();

export const getPopularContentsAsync = createAsyncAction(
  GET_POPULAR_CONTENTS,
  GET_POPULAR_CONTENTS_SUCCESS,
  GET_POPULAR_CONTENTS_ERROR
)<null, GetPopularContentsType, AxiosError>();

export const setSettingId = createAction(
  SET_SETTING_ID,
  (action) => (settingId: mainState['settingId']) => action(settingId)
);
